import {
  formatFuelPrice,
  getFuelStationDisplayName,
  type FuelStation
} from "./amapFuelDemo";

export type RefuelAuthorizationStage = "idle" | "arrived" | "authorized";

export interface RefuelAuthorizationState {
  amountLabel: string;
  authorizationCode: string;
  couponLabel: string;
  gradeLabel: string;
  priceLabel: string;
  queueMinutes: number;
  stage: RefuelAuthorizationStage;
  stationName: string;
}

export const idleRefuelAuthorization: RefuelAuthorizationState = {
  amountLabel: "",
  authorizationCode: "",
  couponLabel: "",
  gradeLabel: "",
  priceLabel: "",
  queueMinutes: 0,
  stage: "idle",
  stationName: ""
};

export function createRefuelAuthorizationPrompt(station: FuelStation): RefuelAuthorizationState {
  return {
    amountLabel: station.amountLabel,
    authorizationCode: "",
    couponLabel: station.couponLabel,
    gradeLabel: station.gradeLabel,
    priceLabel: formatFuelPrice(station.pricePerLiter),
    queueMinutes: station.queueMinutes,
    stage: "arrived",
    stationName: getFuelStationDisplayName(station)
  };
}

export function authorizeRefuel(session: RefuelAuthorizationState): RefuelAuthorizationState {
  if (session.stage === "idle") {
    return session;
  }

  return {
    ...session,
    authorizationCode: session.authorizationCode || generateAuthorizationCode(),
    stage: "authorized"
  };
}

function generateAuthorizationCode() {
  return String(Math.floor(1000 + Math.random() * 9000));
}
